export const SITE = {
  name: "Jen Cullerton Johnson",
  role: "Author · Educator · Speaker",
  email: "jencullertonjohnson@gmail.com",
  phone: "(312) 907-9611",
  phoneHref: "tel:+13129079611",
  location: "Chicago, Illinois",
};

export const NAV_LINKS = [
  { name: "Meet Jen", to: "/about" },
  { name: "Books", to: "/books" },
  { name: "Gallery", to: "/gallery" },
  { name: "Collaborate", to: "/collaborate" },
  { name: "Contact", to: "/contact" },
];

export const MARQUEE_ITEMS = [
  "John Steptoe Award for New Talent in Illustrations",
  "Green Earth Book Award Honor",
  "Bronze FORWARD Indies Award Winner",
  "A bestseller for over a decade",
  "Certified TreeKeeper — City of Chicago",
  "Certified Forest Therapy Guide",
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Storytelling as environmental justice",
    desc: "True stories like Wangari Maathai's teach children that small hands can plant massive forests — and that their voices belong to the living world.",
  },
  {
    num: "02",
    title: "Green Literacy in every K–5 classroom",
    desc: "The Green Literacy Handbook shows educators how to teach critical thinking, reading, writing, and environmental awareness all at once.",
  },
  {
    num: "03",
    title: "Immersive nature & mindfulness",
    desc: "As a certified forest therapy guide, Jen leads walks in Chicago's parks and the Indiana Dunes — because we are not apart from nature, but a part of it.",
  },
];

export const BOOKS = [
  {
    id: "seeds-of-change",
    title: "Seeds of Change: Planting a Path to Peace",
    subtitle: "The picture book biography of Wangari Maathai",
    publisher: "Lee & Low Books",
    year: "2010",
    format: "Picture book · Illustrated by Sonia Lynn Sadler",
    image: "/images/book-seeds-of-change.jpg",
    featured: true,
    description:
      "A picture book biography of scientist Wangari Maathai, the first African woman — and first environmentalist — to win a Nobel Peace Prize (in 2004) for her work planting trees in her native Kenya. As a young girl, Wangari was taught to respect nature; as a scientist, she blazed a trail across Kenya, promoting the rights of her countrywomen and helping save the land, one tree at a time.",
    buyLinks: [
      { name: "Amazon", url: "https://www.amazon.com/Seeds-Change-Wangaris-Gift-World/dp/160060367X/" },
      { name: "Bookshop.org", url: "https://bookshop.org/p/books/seeds-of-change-planting-a-path-to-peace-jen-cullerton-johnson/6421016?ean=9781600603679" },
      { name: "Barnes & Noble", url: "https://www.barnesandnoble.com/w/seeds-of-change-jen-cullerton-johnson/1143401489?ean=9781600603679" },
      { name: "Books-A-Million", url: "https://www.booksamillion.com/p/Seeds-Change/Jen-Cullerton-Johnson/9781600603679?id=9268713283689" },
    ],
    storeNote: "Signed & personalized book bundle — $45",
    storeUrl: "https://www.jencullertonjohnson.com/store/p4/seedsofchangebundle.html",
  },
  {
    id: "semillas-de-cambio",
    title: "Semillas de Cambio",
    subtitle: "Seeds of Change — Spanish edition",
    publisher: "Lee & Low Books",
    year: "2024",
    format: "Picture book · Edición en español",
    image: "/images/book-semillas.webp",
    description:
      "Una biografía ilustrada de la científica Wangari Maathai, la primera mujer africana — y la primera ambientalista — en ganar el Premio Nobel de la Paz por su trabajo sembrando árboles en su Kenia natal. Una narrativa cautivadora e imágenes vibrantes pintan un retrato sólido de esta inspiradora defensora de la tierra y de los derechos de las mujeres.",
    buyLinks: [
      { name: "Lee & Low Books", url: "https://www.leeandlow.com/books/seeds-of-change" },
      { name: "Bookshop.org", url: "https://bookshop.org/search?keywords=Semillas+de+Cambio+Jen+Cullerton+Johnson" },
    ],
  },
  {
    id: "story-wangari",
    title: "The Story of Environmentalist Wangari Maathai",
    subtitle: "The chapter-book edition for growing readers",
    publisher: "Lee & Low Books",
    year: "2019",
    format: "Chapter book · Ages 8+",
    image: "/images/book-chapter.jpg",
    description:
      "This chapter-book edition brings Wangari Maathai's empowering story to life for readers moving up from picture books, with black-and-white illustrations, sidebars on related subjects, a timeline, a glossary, and recommended reading.",
    buyLinks: [
      { name: "Lee & Low Books", url: "https://www.leeandlow.com/books/seeds-of-change" },
      { name: "Bookshop.org", url: "https://bookshop.org/search?keywords=The+Story+of+Environmentalist+Wangari+Maathai" },
    ],
  },
  {
    id: "historia-wangari",
    title: "La Historia de la Ambientalista Wangari Maathai",
    subtitle: "Spanish chapter-book edition",
    publisher: "Lee & Low Books",
    year: "2024",
    format: "Capítulos · En español",
    image: "/images/book-chapter-2.jpg",
    description:
      "La historia de dedicación de Maathai empodera a todos los que amen las bellezas que ofrece el mundo natural. Este libro por capítulos incluye ilustraciones en blanco y negro, barras laterales sobre temas relacionados, una línea de tiempo, un glosario y lecturas recomendadas.",
    buyLinks: [
      { name: "Lee & Low Books", url: "https://www.leeandlow.com/books/seeds-of-change" },
      { name: "Bookshop.org", url: "https://bookshop.org/search?keywords=Wangari+Maathai+Jen+Cullerton+Johnson" },
    ],
  },
];

export const HANDBOOK = {
  title: "The Green Literacy Handbook",
  tagline: "A groundbreaking resource for K–5 educators",
  publisher: "Solution Tree Press · 2025",
  image: "/images/handbook-photo.jpg",
  award: "Bronze FORWARD Indies Award Winner",
  description:
    "The Green Literacy Handbook shows you how to teach critical thinking, reading, writing, and environmental awareness all at once — integrating sustainability and systems thinking into K–5 classrooms with reading, writing, and action.",
  buyUrl: "https://www.solutiontree.com/green-literacy-handbook.html",
  blogUrl: "https://www.linkedin.com/pulse/happy-earth-day-growing-your-green-literacy-jen-cullerton-johnson-wlznc",
};

export const AWARDS = [
  { name: "John Steptoe Award for New Talent in Illustrations", org: "American Library Association (ALA)" },
  { name: "Notable Books for a Global Society", org: "International Literacy Association (ILA)" },
  { name: "Amelia Bloomer Book List", org: "American Library Association (ALA)" },
  { name: "Green Earth Book Award Honor", org: "The Nature Generation" },
  { name: "Young Hoosier Book Award Nominee", org: "Indiana Library Federation" },
  { name: "Great Lakes Great Books Award Nominee", org: "Michigan Reading Association" },
  { name: "United Women in Faith Reading Program", org: "United Methodist Women" },
  { name: "Sigurd F. Olson Nature Writing Award", org: "Northland College" },
];

export const PRAISE = [
  {
    quote: "Richer than other treatments of Maathai for children and more grounded in her work's implicit feminism… Vibrant and accomplished.",
    source: "Kirkus Reviews",
    starred: true,
  },
  {
    quote: "Throughout the book runs the image of the Kikuyu people's sacred mugumo tree… an idea 'as small as a seed but as tall as a tree that reaches for the sky.'",
    source: "Publishers Weekly",
    starred: false,
  },
  {
    quote: "Vivid colors sparkle from within the thick white outlines in the batik-style illustrations that fill the pages.",
    source: "School Library Journal",
    starred: false,
  },
  {
    quote: "Poetic… reinforces the sense of a depleted land growing green again and the presence, even in bustling city scenes, of a vibrant natural world.",
    source: "Booklist",
    starred: false,
  },
];

export const INTERVIEWS = [
  { name: "Growing Your Green Literacy — Solution Tree", url: "https://www.linkedin.com/pulse/happy-earth-day-growing-your-green-literacy-jen-cullerton-johnson-wlznc", pub: "Solution Tree Blog" },
  { name: "Carrying On Wangari Maathai's Legacy", url: "https://www.leeandlow.com/blog/carrying-on-wangari-maathais-legacy-a-call-to-action-for-educators-and-changemakers/", pub: "Lee & Low Blog" },
  { name: "Interview with Jen Cullerton Johnson", url: "https://floweringminds.wordpress.com/2014/09/09/interview-with-jen-cullerton-johnson/", pub: "Flowering Minds" },
  { name: "Author Interview with Jen Cullerton Johnson", url: "https://alisongoldberg.com/author-interview-with-jen-cullerton-johnson/", pub: "Allison Goldberg Blog" },
];

export const GUIDES = [
  { name: "Seeds of Change — Teacher's Guide", url: "https://www.jencullertonjohnson.com/uploads/1/1/0/9/110914603/seeds_of_change_teachers_guide.pdf" },
  { name: "Semillas de Cambio — Teacher's Guide", url: "https://www.jencullertonjohnson.com/uploads/1/1/0/9/110914603/10aa4edf2b1b09a7c3d9.pdf" },
  { name: "The Story of Environmentalist Wangari Maathai — Teacher's Guide", url: "https://www.jencullertonjohnson.com/uploads/1/1/0/9/110914603/the_story_of_environmentalist_wangari_maathai_teachers_guide.pdf" },
];

export const INQUIRY_OPTIONS = [
  { value: "author-visit", label: "Author visit / school program" },
  { value: "workshop-speaking", label: "Workshop or speaking event" },
  { value: "coaching", label: "Creative coaching" },
  { value: "forest-bathing", label: "Forest bathing session" },
  { value: "media-press", label: "Media or press inquiry" },
  { value: "other", label: "Other" },
];

export const WANGARI_QUOTE = {
  text: "When we plant trees, we plant the seeds of peace and the seeds of hope. We also secure the future for our children.",
  author: "Wangari Maathai",
};

export const GALLERY_VISITS = [
  {
    src: "/images/jen-photo-2.jpg",
    alt: "Jen Cullerton Johnson sharing a signed copy of Seeds of Change with a young reader",
    caption: "Sharing a signed copy of Seeds of Change with a young reader",
    tag: "Book events",
    span: "lg:col-span-7",
  },
  {
    src: "/images/event-discovery-center.jpg",
    alt: "Students gathered for a storytime reading of Seeds of Change",
    caption: "Storytime on the road — reading with students",
    tag: "School visits",
    span: "lg:col-span-5",
  },
  {
    src: "/images/jen-event.jpg",
    alt: "Jen with educators and students at a classroom celebration",
    caption: "With educators and students at a classroom celebration",
    tag: "Classrooms",
    span: "lg:col-span-5",
  },
  {
    src: "/images/jen-visits.png",
    alt: "Collage of author visit moments — readings, tree planting, and book giveaways",
    caption: "Readings, tree planting, and book giveaways",
    tag: "In the field",
    span: "lg:col-span-7",
  },
];

export const GALLERY_FOREST = [
  { src: "/images/forest-walk.jpg", alt: "A quiet wooded trail on a forest bathing walk" },
  { src: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "Sunlight falling through a green forest canopy" },
  { src: "https://images.pexels.com/photos/15213897/pexels-photo-15213897.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", alt: "Sand dunes and dune grass on the lakeshore" },
  { src: "https://images.unsplash.com/photo-1605196560547-b2f7281b7355?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "A soft path winding through the forest floor" },
  { src: "https://images.unsplash.com/photo-1507139722691-cc2c94e3a2b2?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "Grassy meadow meeting the tree line" },
];

export const TESTIMONIALS = [
  { quote: "Richer than other treatments of Maathai for children and more grounded in her work's implicit feminism… Vibrant and accomplished.", source: "Kirkus Reviews", kind: "Starred review" },
  { quote: "This book is a wonderfully written true story. The illustrations are very colorful and enhance the story! I loved it!", source: "cindyloo", kind: "Amazon reader review" },
  { quote: "Throughout the book runs the image of the Kikuyu people's sacred mugumo tree… an idea 'as small as a seed but as tall as a tree that reaches for the sky.'", source: "Publishers Weekly", kind: "Trade review" },
  { quote: "Immortalizing a female icon is important. The dialogue is written as informative and picturesque, engaging interests of both children and adults. The book is timeless.", source: "Amazon Customer", kind: "Amazon reader review" },
  { quote: "Vivid colors sparkle from within the thick white outlines in the batik-style illustrations that fill the pages.", source: "School Library Journal", kind: "Trade review" },
  { quote: "EASY TO READ TO KIDS UNDER 6. GREAT FOR 8 YEAR OLD GIRLS.", source: "Amazon Customer", kind: "Amazon reader review" },
  { quote: "Poetic… reinforces the sense of a depleted land growing green again and the presence, even in bustling city scenes, of a vibrant natural world.", source: "Booklist", kind: "Trade review" },
  { quote: "I had a very hard time deciding which book to buy. I finally decided on this book because it gives a complete story from childhood through her accomplishments. The artwork is beautiful.", source: "ScotFlower", kind: "Amazon reader review" },
];

export const VIDEOS = {
  ksnt: "https://www.youtube.com/watch?v=4JrN6P9_0-A",
  hummingbird: "https://www.youtube.com/watch?v=IGMW6YWjMxw",
  readAloud: "https://www.youtube.com/watch?v=fZ90zp48r-g",
  coaching: "https://www.youtube.com/watch?v=H18gHMwjios",
  greenBelt: "https://www.youtube.com/watch?v=hZkeXR7iJas",
  ccrx: "https://www.youtube.com/watch?v=HtGS_qI7cPo",
};
